import React from "react"

import { ContentLeft, Container, Profile, Description, Img, ContentImg } from './styles'

import iconNodejs from '../../assets/icons/NodeJS.svg'
import iconReactjs from '../../assets/icons/ReactJS.svg'
import Button from '../Button'

function Banner() {

  return (
    <header >
      <Container >
        <ContentLeft >
          <h2 >
            Jonas Castro
          </h2>
          <Profile>
            Desenvolvedor Full-stack
          </Profile>
          <Description>
            {/* Olá! Sou Jonas, desenvolvedor Full-Stack com ênfase em <strong><img src={iconReactjs} alt="" />_ReactJS</strong>, <strong><img src={iconReactjs} alt="" />_React Native</strong> e <strong><img src={iconNodejs} alt="" />_NodeJS</strong>. */}

            {/* Olá! Sou Jonas. Atualmente, sou graduando em <strong>Sistemas de Informação</strong> na Universidade Federal do Ceará... */}

            Olá! Sou Jonas. Atualmente, sou 🎓 graduando em <strong>Sistemas de Informação</strong> e Técnico em Informática. Atuo como desenvolvedor de software com foco em aplicações single-page e APIs.
            <br/>
            <br/>
            Principais tecnologias:
              <ul>
                <li>Front-End: <b>Vue.Js</b> | <b>React.Js</b> </li>
                <li>Back-End: <b>NodeJS</b> | <b>NestJS</b>...</li>
                <li>DBs: <b>MySQL</b> | <b>PostgreSQL</b> | <b>MongoDB</b> | <b>ElasticSearch</b></li>
                <li>Outras: <b>Docker</b> | <b>ExpressJS</b> | <b>GraphQL</b>...</li>
              </ul>
             {/* <b><img src={iconReactjs} alt="" /> ReactJS</b> | <strong><img src={iconReactjs} alt="" /> React Native</strong> | <strong><img src={iconNodejs} alt="" /> NodeJS</strong>; */}

            {/* <br />🎓 Atualmente sou aluno do Gostack 🚀Rocketseat: Um treinamento imersivo nas tecnologias mais modernas de desenvolvimento web e mobile; */}

          </Description>
          {/* <Button text="Blog" link='/blog' /> */}
        </ContentLeft>
        {/* <ContentImg>
          <Img
            src="https://avatars2.githubusercontent.com/u/29816458?s=460&u=a21d950fad7bf1453d9b45d4ef13808c75d8cbf1&v=4"
            alt=""
          />
        </ContentImg> */}
      </Container>
    </header >
  )
}

export default Banner
